/**
 * Mega Menu Module
 * Gère les sous-menus en pleine largeur
 * 
 * @package JD_Theme
 */

export function initMegaMenu() {
  const menuItemsWithSubmenu = document.querySelectorAll('#primary-menu > li.menu-item-has-children');
  
  menuItemsWithSubmenu.forEach(item => {
    const submenu = item.querySelector('ul');
    
    if (!submenu) return;
    
    // Déplacer le sous-menu dans le body avec un container
    const submenuClone = submenu.cloneNode(true);
    const menuId = item.className.match(/menu-item-(\d+)/);
    
    if (menuId) {
      submenuClone.id = 'submenu-' + menuId[1];
    }
    
    submenuClone.classList.add('megamenu-dropdown');
    submenuClone.style.display = 'none';
    
    // Wrap items in a container
    const container = document.createElement('div');
    container.className = 'megamenu-container';
    while (submenuClone.firstChild) {
      container.appendChild(submenuClone.firstChild);
    }
    submenuClone.appendChild(container);
    
    document.body.appendChild(submenuClone);
    submenu.remove();
    
    // Fonction pour positionner le mega menu
    const positionMegaMenu = () => {
      const header = document.querySelector('.main-header');
      const headerRect = header.getBoundingClientRect();
      
      Object.assign(submenuClone.style, {
        display: 'block',
        position: 'fixed',
        top: headerRect.bottom + 'px',
        left: '0',
        right: '0',
        width: '100vw',
        zIndex: '10000'
      });
    };
    
    // Listener de scroll pour repositionner si le menu est ouvert
    let scrollListener;
    
    // Au survol du menu item
    item.addEventListener('mouseenter', () => {
      item.classList.add('submenu-open');
      positionMegaMenu();
      
      // Ajouter le listener de scroll
      scrollListener = () => {
        if (submenuClone.style.display === 'flex') {
          positionMegaMenu();
        }
      };
      window.addEventListener('scroll', scrollListener, { passive: true });
    });
    
    // Au départ du menu item
    item.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!submenuClone.matches(':hover') && !item.matches(':hover')) {
          submenuClone.style.display = 'none';
          item.classList.remove('submenu-open');
          // Supprimer le listener de scroll
          if (scrollListener) {
            window.removeEventListener('scroll', scrollListener);
          }
        }
      }, 200);
    });
    
    // Garder ouvert quand on survole le sous-menu
    submenuClone.addEventListener('mouseenter', () => {
      submenuClone.style.display = 'flex';
    });
    
    submenuClone.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!item.matches(':hover')) {
          submenuClone.style.display = 'none';
          item.classList.remove('submenu-open');
          // Supprimer le listener de scroll
          if (scrollListener) {
            window.removeEventListener('scroll', scrollListener);
          }
        }
      }, 200);
    });
  });
}
